export const ARROWS_AI_PLAN_SUPPORT_URL =
  'https://wa.me/+59896218240?text=Hola,%20necesito%20soporte%20de%20Arrows';
